import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import { AuthProvider } from './contexts/AuthContext'

// Add cache busting to force refresh on new deployments
const APP_VERSION = '2025.05.04.1'; // YYYY.MM.DD.build

// Check if we need to refresh due to new version
const lastVersion = localStorage.getItem('app_version');
if (lastVersion && lastVersion !== APP_VERSION) {
  console.log(`[Cache Busting] New version detected! ${lastVersion} → ${APP_VERSION}`);
  localStorage.setItem('app_version', APP_VERSION);
  
  // Clear any application cache
  if ('caches' in window) {
    caches.keys().then(names => {
      names.forEach(name => {
        caches.delete(name);
      });
    });
  }
  
  // Force page refresh to load new assets
  window.location.reload();
} else {
  // First visit or same version
  localStorage.setItem('app_version', APP_VERSION);
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  // Temporarily disable StrictMode to eliminate double renders for debugging
  //<React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  //</React.StrictMode>,
)
